import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler } from 'utils';
import { addSuccessMessage } from '../SnackBar';
import { USERS_PATCH_SUCCESS } from './patchAction';

export const createUserProfile = (userId, profileData) => async dispatch => {
    try {
        const profileRes = await axios(apiRequestOptions(
            apiPath.PROFILES.POST,
            { ...profileData, owner: `/api/users/${userId}` }
        ));

        const profileId = profileRes.data.id;

        const params = [];
        params['id'] = userId;
        const userRes = await axios(apiRequestOptions(
            apiPath.USER.PATCH,
            { profile: `/api/profiles/${profileId}` },
            { params }
        ));

        dispatch(addSuccessMessage('Profile successfully created'));
        dispatch({ type: USERS_PATCH_SUCCESS, user: userRes.data });
    } catch (err) {
        dispatch(errorRequestHandler(err));
        throw err;
    }
};
